import { store } from '../store';
import { registerDevice, addIncomingNotification } from '../store/notificationsSlice';

let cachedDeviceId: string | null = null;

const getOrCreateDeviceId = (): string => {
  if (cachedDeviceId) return cachedDeviceId;

  if (typeof window !== 'undefined' && window.localStorage) {
    let devId = window.localStorage.getItem('pwa_device_id');
    if (!devId) {
      devId = 'ios-pwa-' + Math.random().toString(36).substring(2, 15);
      window.localStorage.setItem('pwa_device_id', devId);
    }
    cachedDeviceId = devId;
    return devId;
  }

  cachedDeviceId = 'pwa-dev-' + Math.random().toString(36).substring(2, 15);
  return cachedDeviceId;
};

const getAppInstanceId = (workspaceId: string): string => {
  if (workspaceId === 'workspace-2') return 'app-2';
  if (workspaceId.startsWith('workspace-')) return workspaceId.replace('workspace-', 'app-');
  return 'app-1';
};

export const initializePushNotifications = async (workspaceId: string) => {
  try {
    const appInstanceId = getAppInstanceId(workspaceId);
    const deviceId = getOrCreateDeviceId();

    if (typeof window === 'undefined' || !('Notification' in window)) {
      console.log('🌐 [PWA Push]: Web Notifications API not supported in current browser context.');
      return;
    }

    // Only request permission if user has already granted or prompts
    if (Notification.permission === 'granted') {
      const mockPushToken = 'web-push-token-' + deviceId;
      await store.dispatch(registerDevice({
        deviceId,
        fcmToken: mockPushToken,
        platform: 'WEB',
        appVersion: '1.0.0',
        appInstanceId
      })).unwrap();
    } else if (Notification.permission !== 'denied') {
      // Don't auto-prompt immediately on load per requirements; permission should be requested in NotificationCenter or Settings
    }
  } catch (err) {
    console.error('❌ [PWA Push]: Error during Web Push registration:', err);
  }
};

export const requestPushPermission = async (workspaceId: string): Promise<boolean> => {
  if (typeof window === 'undefined' || !('Notification' in window)) return false;

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const deviceId = getOrCreateDeviceId();
      const appInstanceId = getAppInstanceId(workspaceId);
      const mockPushToken = 'web-push-token-' + deviceId;

      await store.dispatch(registerDevice({
        deviceId,
        fcmToken: mockPushToken,
        platform: 'WEB',
        appVersion: '1.0.0',
        appInstanceId
      })).unwrap();

      return true;
    }
  } catch (err) {
    console.warn('Failed to request notification permission:', err);
  }
  return false;
};
